import { render, staticRenderFns } from "./DashboardRanking.vue?vue&type=template&id=1a69c214"
import script from "./DashboardRanking.vue?vue&type=script&lang=js"
export * from "./DashboardRanking.vue?vue&type=script&lang=js"
import style0 from "./DashboardRanking.vue?vue&type=style&index=0&id=1a69c214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports